export const LOCAL_PHONE_CLIENT_KEY = "localPhoneClient";

export type LocalPhoneClient = {
    id?: number;
    extensionId?: number;
    identifier?: string;
    domainName?: string;
    sipUser?: string;
    sipPassword?: string;
};

type LocalPhoneClients = Record<string, LocalPhoneClient>;

function parseLocalPhoneClients(): LocalPhoneClients {
    const stored = localStorage.getItem(LOCAL_PHONE_CLIENT_KEY);
    if (stored === null) return {};

    try {
        const parsed: LocalPhoneClients = JSON.parse(stored);

        if (parsed === null || typeof parsed !== "object" || Array.isArray(parsed)) {
            return {};
        }

        return parsed;
    } catch {
        return {};
    }
}

function writeLocalPhoneClients(values: LocalPhoneClients) {
    localStorage.setItem(LOCAL_PHONE_CLIENT_KEY, JSON.stringify(values));
}

export function getLocalPhoneClient(extensionId: number): LocalPhoneClient | null {
    return parseLocalPhoneClients()[extensionId] ?? null;
}

export function updateLocalPhoneClient(extensionId: number, values: LocalPhoneClient) {
    const current = parseLocalPhoneClients();
    const next = {...(current[extensionId] ?? {}), ...values};

    writeLocalPhoneClients({...current, [extensionId]: next});

    return next;
}

export function clearLocalPhoneClient(extensionId: number) {
    const current = parseLocalPhoneClients();
    delete current[extensionId];
    writeLocalPhoneClients(current);
}
